import React from 'react'

const RAF_TERMS_LINK =
  'https://cdn.smarty.co.uk/files/SMARTY-Refer-a-Friend.pdf'

export const content = {
  infoText: (
    <>
      By using this link, you agree for us to share your details with our
      partner, Buyapowa, to fulfil your reward. See{' '}
      <a
        href={RAF_TERMS_LINK}
        target="_blank"
        rel="noreferrer"
        data-testid="terms-link"
      >
        terms
      </a>{' '}
      for more details.
    </>
  ),
  copyCta: 'Copy your link',
}
